import { defineStore } from "pinia";

interface State {
  activeMembers: string[];
}

export const useActiveMembersStore = defineStore("activeMembers", {
  state: (): State => ({
    activeMembers: [],
  }),

  actions: {
    setActiveMembers(activeMembers: string[]) {
      this.activeMembers = activeMembers;
    },
  },
});
